// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  margin: 0;
}

:host {
  display: grid;
  align-content: start;
}

form {
  border: 5px dashed var(--ion-color-light-shade);
  color: var(--ion-color-medium-shade);
  padding: 1rem;
  position: relative;
  border-radius: 24px;
  display: grid;
  place-content: center;
  place-items: center;
  font-size: 20px;
  gap: 24px;
  text-align: center;
  margin-block-end: 16px;
}
form > ion-icon {
  font-size: 96px;
  color: var(--ion-color-light-shade);
  z-index: 1;
}
form.dragover {
  background-color: var(--ion-color-light-tint);
  border-color: var(--ion-color-medium-shade);
}
form.dragover p, form.dragover > ion-icon {
  color: var(--ion-color-medium-shade);
}

ion-button[type=submit] {
  cursor: pointer;
  position: relative;
  z-index: 3;
}

ion-button {
  max-width: max-content;
  justify-self: center;
}
ion-button[type=button] {
  --background: var(--ion-color-danger-shade);
  --color: var(--ion-color-danger-contrast);
}

input {
  position: absolute;
  inset: 0;
  opacity: 0;
  z-index: 2;
}
input:hover {
  cursor: pointer;
}

.instructions {
  font-size: 16px;
  margin-block: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/general-components/drag-and-drop-files/drag-and-drop-files.component.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,oBAAA;AACJ;;AAEA;EACI,+CAAA;EACA,oCAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;AACJ;AACI;EACI,eAAA;EACA,mCAAA;EACA,UAAA;AACR;AAEI;EACI,6CAAA;EACA,2CAAA;AAAR;AAEQ;EAEI,oCAAA;AADZ;;AAMA;EACI,eAAA;EACA,kBAAA;EACA,UAAA;AAHJ;;AAMA;EACI,sBAAA;EACA,oBAAA;AAHJ;AAKI;EACI,2CAAA;EACA,yCAAA;AAHR;;AAQA;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;AALJ;AAOI;EACI,eAAA;AALR;;AASA;EACI,eAAA;EACA,iBAAA;AANJ","sourcesContent":["p {\n    margin: 0;\n}\n\n:host {\n    display: grid;\n    align-content: start;\n}\n\nform {\n    border: 5px dashed var(--ion-color-light-shade);\n    color: var(--ion-color-medium-shade);\n    padding: 1rem;\n    position: relative;\n    border-radius: 24px;\n    display: grid;\n    place-content: center;\n    place-items: center;\n    font-size: 20px;\n    gap: 24px;\n    text-align: center;\n    margin-block-end: 16px;\n\n    &>ion-icon {\n        font-size: 96px;\n        color: var(--ion-color-light-shade);\n        z-index: 1;\n    }\n\n    &.dragover {\n        background-color: var(--ion-color-light-tint);\n        border-color: var(--ion-color-medium-shade);\n\n        p,\n        &>ion-icon {\n            color: var(--ion-color-medium-shade);\n        }\n    }\n}\n\nion-button[type=\"submit\"] {\n    cursor: pointer;\n    position: relative;\n    z-index: 3;\n}\n\nion-button {\n    max-width: max-content;\n    justify-self: center;\n\n    &[type=\"button\"] {\n        --background: var(--ion-color-danger-shade);\n        --color: var(--ion-color-danger-contrast);\n    }\n\n}\n\ninput {\n    position: absolute;\n    inset: 0;\n    opacity: 0;\n    z-index: 2;\n\n    &:hover {\n        cursor: pointer;\n    }\n}\n\n.instructions {\n    font-size: 16px;\n    margin-block: 5px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
